import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import PropTypes from 'prop-types';
import ActivityTable from '../activityTable';
import Chip from 'Chip';

/**
 * 定义 头部活动预告 组件
 */

class ActivityPrediction extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };
    render() {
        const { content } = this.props;

        return (
            <div className={styles.w1180}>
                <div className={styles.h2wrapper}>
                    <h2>活动预告</h2>
                </div>
                <Chip id="50124" type="struct" title="活动预告" groupName="活动列表页面活动预告" content={content}>
                    <ActivityTable />
                </Chip>
            </div>
        );
    }
}

ActivityPrediction.propTypes = {
    content: PropTypes.array,
};
export default errorBoundary(ActivityPrediction);
